// extracted by mini-css-extract-plugin
export default {"form_wrapper":"LoginForm_form_wrapper__ufyyV","gradient-animation":"LoginForm_gradient-animation__x3Izd"};